import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Text3 } from "@churchofjesuschrist/eden-text";
import { lineHeightTight, spacing4 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Link = styled.a.withConfig({
  componentId: "sc-sh97cg-0"
})(["line-height:", ";display:inline-flex;align-items:flex-start;flex-direction:", ";"], lineHeightTight, _ref => {
  let {
    iconPosition
  } = _ref;
  return iconPosition == "start" ? "row" : "row-reverse";
});
const CustomText3 = styled(Text3).withConfig({
  componentId: "sc-sh97cg-1"
})(["line-height:", ";margin-block-start:2px;"], lineHeightTight);
const IconWrapper = styled.div.withConfig({
  componentId: "sc-sh97cg-2"
})(["display:flex;align-items:center;text-decoration:none;", ""], _ref2 => {
  let {
    iconPosition
  } = _ref2;
  return iconPosition === "start" ? `margin-inline-end: ${spacing4}` : `margin-inline-start: ${spacing4}`;
});
const ActionLink = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    Icon,
    iconPosition = "start",
    href,
    children,
    ...rest
  } = _ref3;
  return /*#__PURE__*/_jsxs(Link, {
    ref: ref,
    href: href,
    iconPosition: iconPosition,
    ...rest,
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      iconPosition: iconPosition,
      children: /*#__PURE__*/_jsx(Icon, {
        size: "1.5rem"
      })
    }), /*#__PURE__*/_jsx(CustomText3, {
      children: children
    })]
  });
});
ActionLink.displayName = "ActionLink";
ActionLink.propTypes = {
  /** The link's href */
  href: PropTypes.string.isRequired,
  /** The link's text */
  children: PropTypes.node.isRequired,
  /** The icon for the link, it should be an `eden-icon` */
  Icon: PropTypes.func.isRequired,
  /** The position for the icon */
  iconPosition: PropTypes.oneOf(["start", "end"])
};
export default ActionLink;